export const SERVICE_UNAVAILABLE_BANNER_DOCUMENT_ID = 'service_unavailability_banner'